import createIcon from '../../createIcon';

/**
 * @component @name FormatAlignCenter
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNyAxNVYxN0gxN1YxNUg3Wk0zIDIxSDIxVjE5SDNWMjFaTTMgMTNIMjFWMTFIM1YxM1pNNyA3VjlIMTdWN0g3Wk0zIDNWNUgyMVYzSDNaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const FormatAlignCenter = createIcon('FormatAlignCenter', [
  [
    'path',
    {
      d: 'M7 15V17H17V15H7ZM3 21H21V19H3V21ZM3 13H21V11H3V13ZM7 7V9H17V7H7ZM3 3V5H21V3H3Z',
      key: '4ipngy',
    },
  ],
]);

export default FormatAlignCenter;
